




































































































































































































































































































































































































import {
  computed,
  defineNuxtComponent,
  ref,
  onMounted
} from '~/utils/nuxt3-migration'
import { useClassifiedSearchResultRow } from '~/compositions/classified-search/useClassifiedSearchResultRow'
import ClassifiedSearchResultsRowCensoredOverlay from '~/components/car/classifieds/search/results/ClassifiedSearchResultsRowCensoredOverlay.vue'
import ClassifiedSearchResultsRowPromoRibbon from '~/components/car/classifieds/search/results/ClassifiedSearchResultsRowPromoRibbon.vue'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS } from '~/store/modules/shared/user/state'
import { ciAngleRight as ciAngleRightSolid } from '~/icons/source/solid/angle-right'
import { ciAngleRight as ciAngleRightRegular } from '~/icons/source/regular/angle-right'
import { ciCamera } from '~/icons/source/regular/camera'
import { ciYoutube } from '~/icons/source/solid/youtube'
import { ciAngleLeft } from '~/icons/source/solid/angle-left'
import { ciLocationPin } from '~/icons/source/regular/location-pin'
import { ciCog } from '~/icons/source/solid/cog'
import { ciEnvelope } from '~/icons/source/solid/envelope'
import { ciClock } from '~/icons/source/regular/clock'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import ClassifiedSearchResultsRowBadges from '~/components/car/classifieds/search/results/ClassifiedSearchResultsRowBadges.vue'
import CClassifiedCompareButton from '~/components/shared/configurable/classified/compare/CClassifiedCompareButton.vue'
import CClassifiedFavoriteButton from '~/components/shared/configurable/classified/favorite/CClassifiedFavoriteButton.vue'
import PaidClassifiedInfo from '~/components/car/classifieds/search/results/rows/main/partials/PaidInfo/PaidClassifiedInfo.vue'
import ClassifiedSearchResultsRowActions from '~/components/car/classifieds/search/results/ClassifiedSearchResultsRowActions.vue'
import { MODIFY_ROW_PARKED } from '~/store/modules/shared/classifieds/search/mutation-types'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { useDeps } from '~/compositions/dependency-container'
import CompareService from '~/services/compare/CompareService'
import { PropType } from 'vue'
import { ClassifiedSearchResultRow } from '~/models/search/types'

export default defineNuxtComponent({
  components: {
    CClassifiedFavoriteButton,
    CClassifiedCompareButton,
    ClassifiedSearchResultsRowBadges,
    CPrice,
    ClassifiedSearchResultsRowPromoRibbon,
    ClassifiedSearchResultsRowCensoredOverlay,
    ClassifiedSearchResultsRowActions,
    PaidClassifiedInfo
  },
  props: {
    classified: {
      type: Object as PropType<ClassifiedSearchResultRow>,
      required: true
    },
    lazyLoadImage: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { getters: userGetters } = useNamespacedStore(USER_NS)
    const { commit: classifiedSearchCommit } = useNamespacedStore(
      CLASSIFIED_SEARCH_NS
    )
    const [compareService] = useDeps(CompareService)
    const {
      rowBgClass,
      href,
      isCensored,
      isPromoted,
      isTouchingImage,
      isRentalClassified,
      isJobWantedClassified,
      isForRent,
      isJobClassified,
      isPartClassified,
      isXymaClassified,
      classifiedImg,
      classifiedBackgroundJobs,
      imageLoading,
      images,
      currentImageIndex,
      rootCategoryId,
      showCompareButton,
      showSellerInfo,
      showActions,
      classifiedRequiresPayment,
      classifiedImgContainerClass,
      lastModifiedDate,
      onMessageClick,
      onSetActivePromotion,
      onImageTouchStart,
      onImageTouchEnd,
      onRowClick,
      loadPreviousImage,
      loadNextImage
    } = useClassifiedSearchResultRow(props.classified)

    const badgesRef = ref<typeof ClassifiedSearchResultsRowBadges>()
    const hasBadges = ref(false)
    const actionsAreCollapsed = ref(false)

    onMounted(() => {
      if (!badgesRef.value) {
        return
      }

      hasBadges.value = badgesRef.value.$el?.children?.length
    })

    const userIsManager = computed(() => userGetters('isManager'))

    function onParked(isParked: boolean) {
      classifiedSearchCommit(MODIFY_ROW_PARKED, {
        classifiedId: props.classified.id,
        parked: isParked
      })
    }

    async function onCompareButtonClick(classifiedId: number) {
      await compareService.setComparedClassified(
        rootCategoryId.value,
        classifiedId
      )
    }

    return {
      ciCog,
      ciAngleRightSolid,
      ciCamera,
      ciYoutube,
      ciAngleLeft,
      ciLocationPin,
      ciAngleRightRegular,
      ciEnvelope,
      ciClock,
      showActions,
      classifiedImgContainerClass,
      actionsAreCollapsed,
      badgesRef,
      isTouchingImage,
      isCensored,
      isPromoted,
      isRentalClassified,
      isForRent,
      isJobClassified,
      isJobWantedClassified,
      isPartClassified,
      isXymaClassified,
      hasBadges,
      href,
      rowBgClass,
      userIsManager,
      classifiedImg,
      imageLoading,
      images,
      currentImageIndex,
      classifiedBackgroundJobs,
      showCompareButton,
      rootCategoryId,
      showSellerInfo,
      classifiedRequiresPayment,
      lastModifiedDate,
      onParked,
      onCompareButtonClick,
      onImageTouchEnd,
      onMessageClick,
      onSetActivePromotion,
      onImageTouchStart,
      loadPreviousImage,
      loadNextImage,
      onRowClick
    }
  }
})
